import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const PemutusanRelasi = Loadable(lazy(() => import('./index')));
const FormPemutusanRelasi = Loadable(lazy(() => import('./form/index')));

const Approval = Loadable(lazy(() => import('./approval/index')))
const ApprovalForm = Loadable(lazy(() => import('./approval/form/index')))

export const routes: RouteObject[] = [
    {
        path: '/list/kelola-nasabah/pemutusan-relasi-bsya-junior',
        element: <PemutusanRelasi />,
    },

    {
        path: '/form/kelola-nasabah/pemutusan-relasi-bsya-junior/:id',
        element: <FormPemutusanRelasi />,
    },

    {
        path: '/list/persetujuan/pemutusan-relasi-bsya-junior',
        element: <Approval />
    },

    {
        path: '/form/persetujuan/pemutusan-relasi-bsya-junior/:id',
        element: <ApprovalForm />,
    },

];
